import Nav from "../components/Nav/nav";
import About from "../components/About/aboutnew";
import Whatsapp from "../Whatsapp/whatsapp";
const AboutPage = () => {
  return (
    <div>
      <Nav />
      <About />
      <Whatsapp />
    </div>
  );
};

export default AboutPage;
